/**
 * The sliding highlight behind the active tab.
 *
 * One element with a shared `layoutId` animates between tabs as the selection
 * moves, rather than each tab cross-fading its own background. Several strips
 * use it (locations, the shared sent/received toggle, the facet rows), so it
 * lives on its own — each strip passes a distinct layoutId.
 */

import { motion } from 'framer-motion';

export const TabPill = motion.span;
